import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLanguage } from "@/i18n/LanguageContext";
import SessionBookingFlow from "@/components/panel/SessionBookingFlow";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Centered booking dialog (used outside the mentoring popover). */
const RequestSessionModal = ({ open, onOpenChange }: Props) => {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[min(560px,calc(100vw-2rem))] max-w-none max-h-[88vh] p-0 flex flex-col gap-0 overflow-hidden rounded-2xl border border-border shadow-2xl">
        <DialogHeader className="px-5 pt-5 pb-3 border-b border-border/60 shrink-0">
          <DialogTitle className="font-display text-xl text-left">{t("mentoringBooking", "title")}</DialogTitle>
        </DialogHeader>

        <SessionBookingFlow active={open} onClose={() => onOpenChange(false)} variant="dialog" />
      </DialogContent>
    </Dialog>
  );
};

export default RequestSessionModal;
